module.exports = __webpack_public_path__ + "img/auth_educloud.ac9560c3.svg";